var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6497 20.6858C12.8903 20.6858 12.2747 21.3014 12.2747 22.0608C12.2747 22.8202 12.8903 23.4358 13.6497 23.4358H26.9831C27.7424 23.4358 28.3581 22.8202 28.3581 22.0608C28.3581 21.3014 27.7424 20.6858 26.9831 20.6858H13.6497Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2747 28.7275C12.2747 27.9681 12.8903 27.3525 13.6497 27.3525H26.9831C27.7424 27.3525 28.3581 27.9681 28.3581 28.7275C28.3581 29.4869 27.7424 30.1025 26.9831 30.1025H13.6497C12.8903 30.1025 12.2747 29.4869 12.2747 28.7275Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6497 14.0193C12.8903 14.0193 12.2747 14.6349 12.2747 15.3943C12.2747 16.1536 12.8903 16.7693 13.6497 16.7693H16.9831C17.7424 16.7693 18.3581 16.1536 18.3581 15.3943C18.3581 14.6349 17.7424 14.0193 16.9831 14.0193H13.6497Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60815 7.06087C5.60815 4.46053 7.71615 2.35254 10.3165 2.35254H23.6497L23.6628 2.3526C23.9742 2.35549 24.2609 2.46194 24.4901 2.63917C24.5363 2.67482 24.5804 2.71357 24.6221 2.75527L34.6221 12.7553C34.6697 12.8029 34.7135 12.8537 34.7533 12.9072C34.8979 13.1014 34.9925 13.3352 35.0179 13.5893C35.0225 13.635 35.0248 13.6812 35.0248 13.7275V33.7275C35.0248 36.3279 32.9168 38.4359 30.3165 38.4359H10.3165C7.71615 38.4359 5.60815 36.3279 5.60815 33.7275V7.06087ZM10.3165 5.10254H22.2747V13.7275C22.2747 14.4869 22.8903 15.1025 23.6497 15.1025H32.2748V33.7275C32.2748 34.8091 31.398 35.6859 30.3165 35.6859H10.3165C9.23493 35.6859 8.35815 34.8091 8.35815 33.7275V7.06087C8.35815 5.97931 9.23493 5.10254 10.3165 5.10254ZM25.0247 7.04698L30.3303 12.3525H25.0247V7.04698Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.ea2e747a195e9b3770f39b58f7689fe6.svg";
export { ForwardRef as ReactComponent };